import { createTheme, ThemeProvider } from "@mui/material/styles";
import SignIn from "./components/SignIn";
import SignUp from "./components/SignUp";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import Home from "./pages/Home";
import ResponsiveAppBar from "./components/ResponsiveAppBar";
import About from "./pages/About";
import Contact from "./pages/Contact";
import { AuthProvider } from "./context/AuthContext";
import MenuDetail from "./components/MenuDetail";
import Footer from "./components/Footer";
import Checkout from "./pages/Checkout";
import ShoppingCart from "./pages/ShoppingCart";
import { CartProvider } from "./context/CartContext";
import Profile from "./pages/Profile";
import Menu from "./pages/Menu";
import MyOrders from "./pages/MyOrders";
import theme from "./theme";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
//import getLPTheme from "./getLPTheme";

function App() {
  //const LPtheme = createTheme(getLPTheme());
  const defaultTheme = createTheme(theme);

  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      <AuthProvider>
        <CartProvider>
          <Router>
            <ResponsiveAppBar />
            <Routes>
              <Route path="/signin" element={<SignIn />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/" element={<Home />} />
              <Route path="/menu" element={<Menu />} />
              <Route path="/menu/:menuId" element={<MenuDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/shopping-cart" element={<ShoppingCart />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/myorders" element={<MyOrders />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
            </Routes>
            <Footer />
          </Router>
        </CartProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
